<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Home Page</title>
  <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css" rel="stylesheet">
  <link href="https://cdn.jsdelivr.net/npm/animate.css" rel="stylesheet">
  <link rel="stylesheet" href="home-page.component.scss">
</head>

<body>
  <div class="text-center mt-4 container2">
    <a class="mail-call" href="tel:04633 283133">
      <span class="fa fa-phone phone-custom"
        style="color: #077A7D;background: linear-gradient(#077A7D, #7AE2CF); font-size: 20px; text-decoration: none ;padding: 3px; color: white;"
        aria-hidden="true"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </a>
    <a class="mail-call1" href="mailto:sriparasakthividyala@yahoo.co.in">
      <span class="fa fa-envelope"
        style="font-size: 20px;  color: #077A7D;background: linear-gradient(#077A7D, #7AE2CF); color: white; padding: 3px; "></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </a>
    <a class="mail-call2" href="https://wa.me/8122983133" target="_blank">
      <i class="fab fa-whatsapp"
        style="color: #077A7D;background: linear-gradient(#077A7D, #7AE2CF); color: white;; font-size: 20px; padding: 3px;"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </a>
  </div>
  <br>
  <div class="container my-5">
    <div class="row">
      <div class="row mb-4 text-center">
        <div class="col-md-6">
          <img src="../../assets/img/Acsirimg.jpeg" alt="A/C Sir Image"
            style="width: 100%; max-width: 550px; height: auto; border-radius: 10px; box-shadow: 0 4px 10px rgba(0,0,0,0.15);"
            loading="lazy">
        </div>

        <div class="col-md-6 d-flex align-items-center justify-content-start">
          <div
            style="text-align: left; background: #f9f9f9; padding: 25px; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); line-height: 1.6;">
            <h3 style="font-weight: bold; color: #2c3e50; margin-bottom: 10px;">Thiru. K. ARUMUGAM B.A., B.L.,</h3>
            <h5 style="margin: 0; font-size: 16px; color: #555;">Assistant Commissioner,<br>
              Executive Officer,<br>
              Arulmigu Thirukuttralanatha Swami Thirukovil,<br>
              Courtallam.</h5>
            <hr style="margin: 15px 0;">
            <h5 style="margin: 0; font-size: 16px; color: #333; font-weight: 500;">
              <strong>SECRETARY,</strong><br>SRI PARASAKTHI VIDYALAYA - CBSE, COURTALLAM
            </h5>
          </div>
        </div>
      </div>
      &nbsp;
      <div class="row mb-4 text-center">
        <div class="col-md-6">
          <img src="../../assets/img/principalimg.jpeg" alt="Principal Image"
            style="width: 100%; max-width: 550px; height: auto; border-radius: 10px; box-shadow: 0 4px 10px rgba(0,0,0,0.15);"
            loading="lazy">
        </div>

        <div class="col-md-6 d-flex align-items-center justify-content-start">
          <div
            style="text-align: left; background: #f9f9f9; padding: 25px; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); line-height: 1.6;">
            <h3 style="font-weight: bold; color: #2c3e50; margin-bottom: 10px;">Ms P. JEYALAKSHMI M.A.B.Ed.,</h3>
            <h5 style="margin: 0; font-size: 16px; color: #555;">PRINCIPAL,</h5>
            <hr style="margin: 15px 0;">
            <h5 style="margin: 0; font-size: 16px; color: #333; font-weight: 500;">
              <strong>SRI PARASAKTHI VIDYALAYA - CBSE, COURTALLAM.</strong>
            </h5>
          </div>
        </div>
      </div>

    </div>
  </div>


  <!-- <div class="slideshow-container">
    <div class="slide" *ngFor="let slide of slides; let i = index" [class.active]="i === currentIndex">
      <img [src]="slide.image" alt="Slide Image" class="slide-image" />
      <div class="caption">{{ slide.caption }}</div>
    </div>
  </div> -->
  <!-- <div class="gallery-container"> -->
  <!-- <div *ngIf="images.length === 0">No images available.</div> -->
  <!-- <div *ngFor="let image of images" class="image-item"> -->
  <!-- <div class="image-wrapper"> -->
  <!-- <img [src]="image.filePath" [alt]="image.name" /> -->
  <!-- </div> -->
  <!-- <p>{{ image.name }}</p> -->
  <!-- </div> -->
  <!-- </div> -->
  <br>
  <br>
  <div class="row text-center">
    <div class="col-md-4 col-sm-12 my-3">
      <div class="card border-0 shadow-lg hover-card h-100">
        <div class="card-body d-flex flex-column justify-content-between">
          <div>
            <div class="icon-container text-primary">
              <i class="fa fa-graduation-cap fa-2x"></i>
            </div>
            <h5 class="card-title font-weight-bold mt-3">ABOUT OUR SCHOOL</h5>
            <p class="card-text text-muted">
              Learn about our legacy, vision, and commitment to academic excellence.
            </p>
          </div>
          <div class="text-center">
            <button class="btn mt-2" routerLink="/about-us"
              style="color: black; background-color: #7AE2CF; border: none; width: 150px;">
              Discover More
            </button>
          </div>

        </div>
      </div>
    </div>

    <div class="col-md-4 col-sm-12 my-3">
      <div class="card border-0 shadow-lg hover-card h-100">
        <div class="card-body d-flex flex-column justify-content-between">
          <div>
            <div class="icon-container text-success">
              <i class="fa fa-file-text-o fa-2x"></i>
            </div>
            <h5 class="card-title font-weight-bold mt-3">ADMISSIONS</h5>
            <p class="card-text text-muted">
              Explore our simple admission process and start your journey with us today.
            </p>
          </div>
          <div style="text-align: center;">
            <button class="btn mt-3" routerLink="/contact-us"
              style="color: black; background-color: #7AE2CF; border: none;">
              Apply Now
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-sm-12 my-3">
      <div class="card border-0 shadow-lg hover-card h-100">
        <div class="card-body d-flex flex-column justify-content-between">
          <div>
            <div class="icon-container text-danger">
              <i class="fa fa-book fa-2x"></i>
            </div>
            <h5 class="card-title font-weight-bold mt-3">ACADEMICS</h5>
            <p class="card-text text-muted">
              Discover our curriculum, extracurriculars, and academic support programs.
            </p>
          </div>
          <div style="text-align: center;">
            <button class="btn mt-3" routerLink="/verticals"
              style="color: black; background-color: #7AE2CF; border: none;">
              Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br>
  <div style="flex: 1; height: 2px; background: #ddd; margin: 0 10px; position: relative;">
    <i class="fa fa-rocket"
      style="position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: #fff; padding: 5px; color: #077A7D; border-radius: 50%;"></i>
  </div>
  <br>
  <div class="container my-5">
    <div class="row">
      <!-- Our Philosophy -->
      <div class="col-md-6 text-start">
        <h3><i class="fa fa-lightbulb text-primary"></i>&nbsp;OUR PHILOSOPHY</h3>
        <p class="font-weight-bold text-muted">
          We believe in shaping well-rounded individuals by balancing academic excellence with moral values, creativity,
          and co-curricular engagement.
        </p>
      </div>

      <!-- Why Choose Us -->
      <div class="col-md-6 text-end">
        <h3><i class="fa fa-star text-success"></i>&nbsp;WHY CHOOSE US</h3>
        <p class="font-weight-bold text-muted">
          Our school provides a safe and nurturing environment with qualified educators, modern facilities, and a strong
          focus on individual student growth and leadership.
        </p>
      </div>
    </div>
  </div>

  <br>
  <div style="flex: 1; height: 2px; background: #ddd; margin: 0 10px; position: relative;">
    <i class="fa fa-rocket"
      style="position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: #fff; padding: 5px; color: #077A7D; border-radius: 50%;"></i>
  </div>
  <div class="container my-5 py-5 rounded shadow text-white" style="background: linear-gradient(#077A7D, #7AE2CF);">
    <div class="row align-items-center">
      <div class="col-md-8">
        <h2 class="font-weight-bold">Join Our Learning Community</h2>
        <p class="lead">
          Discover how our school nurtures excellence, creativity, and values in every child.
          Reach out to us to learn more about admissions, academics, and student life.
        </p>
      </div>
      <div class="col-md-4 text-md-end text-center mt-4 mt-md-0">
        <button class="btn btn-light btn-lg px-4 py-2" routerLink="/contact-us">
          Get in Touch
        </button>
      </div>
    </div>
  </div>
  <br>
  <div style="flex: 1; height: 2px; background: #ddd; margin: 0 10px; position: relative;">
    <i class="fa fa-rocket"
      style="position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: #fff; padding: 5px; color: #077A7D; border-radius: 50%;"></i>
  </div>
</body>

</html>